/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".dummy_906d3fd1{background:blue}\n"}]);
export const dummy = "dummy_906d3fd1";